import React, { useEffect, useState } from 'react';
import { ReactComponent as XlsUploadIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as XlsReviewIcon } from 'assets/icons/meals.svg';
import { Outlet, useLocation } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS, ROUTE_PREFIX, selectionTypeList } from 'utils/constants';
import RightSidebar from 'components/right-sidebar';
import BottomNavigation from 'components/bottom-navigation';
import useBaseAddonCategoryXlsContext from 'contexts/base-addon-category-xls.context';
import { apiService } from 'services/base.service';
import { SuccessModal } from 'components/base/success-modal';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { getTrimmedPath } from 'utils/functions';

const BaseAddonCategoryXlsContent = () => {
  const { setRightSection } = useDashboardContext();
  const { mappedAddons, setMappedAddons, addons } = useBaseAddonCategoryXlsContext();

  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const BASE_ADDON_CATEGORY_XLS_NAV_LIST = [
    {
      title: 'Upload Files',
      link: `${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS}/${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS_UPLOAD}`,
      Icon: XlsUploadIcon
    },
    {
      title: 'Review Items',
      link: `${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS}/${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS_REVIEW}`,
      Icon: XlsReviewIcon
    }
  ];

  const { pathname } = useLocation();

  const onNextClick = () => {
    if (addons && pathname.includes('upload')) {
      setMappedAddons(
        addons.map((addon) => ({
          ref: addon.ref,
          name: addon.name,
          subtitle: addon.subtitle,
          description: addon.description,
          selection_type: addon.selection_type,
          min_selection: addon.min_selection,
          max_selection: addon.max_selection,
          hasError: !addon.name || !addon.ref || !addon.description || !addon.selection_type
        }))
      );
    }
  };

  const addBaseAddonCategory = async () => {
    setLoading(true);
    const payload = {
      base_addon_categories: mappedAddons.map((addon) => ({
        slug: addon?.ref,
        name: addon?.name,
        summary: addon?.subtitle ?? '',
        description: addon?.description ?? '',
        meal_category_selection_type_id:
          selectionTypeList.find((item) => item.text.toUpperCase() === addon?.selection_type)
            ?.value ?? selectionTypeList[0].value,
        min_selection_no:
          addon?.min_selection !== undefined ? String(addon?.min_selection) : undefined,
        selection_no:
          addon?.max_selection !== undefined ? String(addon?.max_selection) : undefined ?? '0'
      }))
    };
    try {
      const res = await apiService.post('base-addon-category/bulk', {
        data: payload,
        isInternal: true
      });
      if (res?.data) setShowSuccess(true);
    } catch (err: any) {
      console.log(err);
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setRightSection(<RightSidebar list={BASE_ADDON_CATEGORY_XLS_NAV_LIST} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const isDisabled = () => {
    if (`/${getTrimmedPath()}` === BASE_ADDON_CATEGORY_XLS_NAV_LIST[0].link)
      return addons.length == 0;
  };

  return (
    <div>
      <Outlet />
      <BottomNavigation
        list={BASE_ADDON_CATEGORY_XLS_NAV_LIST}
        onConfirm={addBaseAddonCategory}
        loading={loading}
        disabled={isDisabled()}
        onNextClick={onNextClick}
      />
      <SuccessModal
        onClose={() => setShowSuccess(false)}
        show={showSuccess}
        link={`${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.BASE_ADDON_CATEGORY}`}
        linkText='Back to base addon categories'>
        Base Addon Categories Created Successfully
      </SuccessModal>
    </div>
  );
};

export default BaseAddonCategoryXlsContent;
